import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppContextService {
  private _isMoodle: boolean = false;

  constructor() {
    const stored = sessionStorage.getItem('isMoodle');
    if (stored === 'true') {
      this._isMoodle = true;
    }
  }

  setMoodleMode(isMoodle: boolean): void {
    this._isMoodle = isMoodle;
    sessionStorage.setItem('isMoodle', String(isMoodle));
  }

  get isMoodle(): boolean {
    return this._isMoodle;
  }
}